export default "__VITE_ASSET__6af63964__"